import { useEffect, useState } from "react";
import Navbar from "../../components/Navbar";
import api from "../../services/api";

export default function ManageUsers() {
  const [users, setUsers] = useState([]);
  const [departments, setDepartments] = useState([]);
  const [blocks, setBlocks] = useState([]);

  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [role, setRole] = useState("department");

  const [departmentId, setDepartmentId] = useState("");
  const [blockId, setBlockId] = useState("");

  const loadData = () => {
    api.get("/admin/users").then((res) => setUsers(res.data));

    api.get("/admin/departments").then((res) => setDepartments(res.data));

    api.get("/admin/blocks").then((res) => setBlocks(res.data));
  };

  useEffect(() => {
    loadData();
  }, []);

  /* Create User */

  const addUser = async () => {
    if (!name || !email || !password) {
      alert("Please fill required fields");
      return;
    }

    /* Role validation */

    if (role === "department" && !departmentId) {
      alert("Select department");
      return;
    }

    if (role === "bdo" && !blockId) {
      alert("Select block");
      return;
    }

    await api.post("/admin/users", {
      name,
      email,
      password,
      role,
      department_id: role === "department" ? departmentId : null,
      block_id: role === "bdo" ? blockId : blockId || null,
    });

    setName("");
    setEmail("");
    setPassword("");
    setDepartmentId("");
    setBlockId("");

    loadData();
  };
  const deleteUser = async (id) => {
    const confirmDelete = window.confirm("Are you sure you want to delete this user?");
  
    if (!confirmDelete) return;
  
    try {
      await api.delete(`/admin/users/${id}`);
      loadData(); // refresh list
    } catch (err) {
      console.log(err);
      alert("Delete failed");
    }
  };
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />

      <div className="max-w-4xl mx-auto p-10">
        <h2 className="text-2xl font-bold mb-6">Manage Users</h2>

        {/* Create User */}

        <div className="bg-white shadow rounded p-6 mb-8">
          <input
            placeholder="Name"
            value={name}
            className="border p-2 mb-3 w-full"
            onChange={(e) => setName(e.target.value)}
          />

          <input
            placeholder="Email"
            value={email}
            className="border p-2 mb-3 w-full"
            onChange={(e) => setEmail(e.target.value)}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            className="border p-2 mb-3 w-full"
            onChange={(e) => setPassword(e.target.value)}
          />

          {/* Role */}

          <select
            value={role}
            className="border p-2 mb-3 w-full"
            onChange={(e) => setRole(e.target.value)}
          >
            <option value="department">Department User</option>

            <option value="bdo">BDO</option>
          </select>

          {/* Department Field */}

          {role === "department" && (
            <select
              value={departmentId}
              className="border p-2 mb-3 w-full"
              onChange={(e) => setDepartmentId(e.target.value)}
            >
              <option value="">Select Department</option>

              {departments.map((d) => (
                <option key={d.id} value={d.id}>
                  {d.name}
                </option>
              ))}
            </select>
          )}

          {/* Block Field */}

          <select
            value={blockId}
            className="border p-2 mb-4 w-full"
            onChange={(e) => setBlockId(e.target.value)}
          >
            <option value="">District Level (No Block)</option>

            {blocks.map((b) => (
              <option key={b.id} value={b.id}>
                {b.name}
              </option>
            ))}
          </select>

          <button
            onClick={addUser}
            className="bg-red-600 text-white px-4 py-2 rounded"
          >
            Create User
          </button>
        </div>

        {/* Users List */}

        <div className="bg-white shadow rounded">
        {users.map((u) => (
  <div
    key={u.id}
    className="border-b p-4 flex justify-between items-center"
  >
    <div>
      <strong>{u.name}</strong> — {u.email}

      <div className="text-sm text-gray-500 mt-1">
        Role: {u.role}
        <br />
        Department: {u.department || "N/A"}
        <br />
        Block: {u.block || "District Level"}
      </div>
    </div>

    {/* DELETE BUTTON */}
    <button
      onClick={() => deleteUser(u.id)}
      className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
    >
      Delete
    </button>
  </div>
))}
        </div>
      </div>
    </div>
  );
}
